export default "__VITE_ASSET__bcf7fac2__"